import type { RouteRecordRaw } from 'vue-router'
import { UiKitNs } from '@shared/types'

export const uiKitRoutes: RouteRecordRaw[] = [
  {
    path: '/ui',
    component: () => import('./layouts/ui-kit.layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'css-tokens',
        name: UiKitNs.RouteEnums.CSS_TOKENS,
        component: () => import('./views/css-tokens.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Color Tokens' },
      },
      {
        path: 'css-tokens/scale',
        name: UiKitNs.RouteEnums.CSS_TOKENS_SCALE,
        component: () => import('./views/css-tokens.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Scale Tokens' },
      },
      {
        path: 'typography',
        name: UiKitNs.RouteEnums.TYPOGRAPHY,
        component: () => import('./views/typography.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Typography' },
      },
      {
        path: 'scrollbar',
        name: UiKitNs.RouteEnums.SCROLLBAR,
        component: () => import('./views/scrollbar.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Scrollbar' },
      },
      {
        path: 'components',
        redirect: { name: UiKitNs.RouteEnums.BUTTON },
      },
      {
        path: 'components/accordion',
        name: UiKitNs.RouteEnums.ACCORDION,
        component: () => import('./views/accordion.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Accordion' },
      },
      {
        path: 'components/avatar',
        name: UiKitNs.RouteEnums.AVATAR,
        component: () => import('./views/avatar.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Avatar' },
      },
      {
        path: 'components/breadcrumb',
        name: UiKitNs.RouteEnums.BREADCRUMB,
        component: () => import('./views/breadcrumb.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Breadcrumb' },
      },
      {
        path: 'components/button',
        name: UiKitNs.RouteEnums.BUTTON,
        component: () => import('./views/button.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Button' },
      },
      {
        path: 'components/button-group',
        name: UiKitNs.RouteEnums.BUTTON_GROUP,
        component: () => import('./views/button-group.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Button Group' },
      },
      {
        path: 'components/card',
        name: UiKitNs.RouteEnums.CARD,
        component: () => import('./views/card.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Card' },
      },
      {
        path: 'components/checkbox',
        name: UiKitNs.RouteEnums.CHECKBOX,
        component: () => import('./views/checkbox.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Checkbox' },
      },
      {
        path: 'components/combobox',
        name: UiKitNs.RouteEnums.COMBOBOX,
        component: () => import('./views/combobox.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Combobox' },
      },
      {
        path: 'components/command',
        name: UiKitNs.RouteEnums.COMMAND,
        component: () => import('./views/command.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Command' },
      },
      {
        path: 'components/composer',
        name: UiKitNs.RouteEnums.COMPOSER,
        component: () => import('./views/composer.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Composer' },
      },
      {
        path: 'components/questionnaire',
        name: UiKitNs.RouteEnums.QUESTIONNAIRE,
        component: () => import('./views/questionnaire.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Questionnaire' },
      },
      {
        path: 'components/context-menu',
        name: UiKitNs.RouteEnums.CONTEXT_MENU,
        component: () => import('./views/context-menu.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Context Menu' },
      },
      {
        path: 'components/dialog',
        name: UiKitNs.RouteEnums.DIALOG,
        component: () => import('./views/dialog.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Dialog' },
      },
      {
        path: 'components/dropdown-menu',
        name: UiKitNs.RouteEnums.DROPDOWN_MENU,
        component: () => import('./views/dropdown-menu.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Dropdown Menu' },
      },
      {
        path: 'components/dropzone',
        name: UiKitNs.RouteEnums.DROPZONE,
        component: () => import('./views/dropzone.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Dropzone' },
      },
      {
        path: 'components/field',
        name: UiKitNs.RouteEnums.FIELD,
        component: () => import('./views/field.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Field' },
      },
      {
        path: 'components/input',
        name: UiKitNs.RouteEnums.INPUT,
        component: () => import('./views/input.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Input' },
      },
      {
        path: 'components/input-group',
        name: UiKitNs.RouteEnums.INPUT_GROUP,
        component: () => import('./views/input-group.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Input Group' },
      },
      {
        path: 'components/alert',
        name: UiKitNs.RouteEnums.ALERT,
        component: () => import('./views/alert.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Alert' },
      },
      {
        path: 'components/badge',
        name: UiKitNs.RouteEnums.BADGE,
        component: () => import('./views/badge.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Badge' },
      },
      {
        path: 'components/kbd',
        name: UiKitNs.RouteEnums.KBD,
        component: () => import('./views/kbd.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Kbd' },
      },
      {
        path: 'components/meter',
        name: UiKitNs.RouteEnums.METER,
        component: () => import('./views/meter.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Meter' },
      },
      {
        path: 'components/pagination',
        name: UiKitNs.RouteEnums.PAGINATION,
        component: () => import('./views/pagination.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Pagination' },
      },
      {
        path: 'components/popover',
        name: UiKitNs.RouteEnums.POPOVER,
        component: () => import('./views/popover.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Popover' },
      },
      {
        path: 'components/radio-group',
        name: UiKitNs.RouteEnums.RADIO_GROUP,
        component: () => import('./views/radio-group.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Radio Group' },
      },
      {
        path: 'components/select',
        name: UiKitNs.RouteEnums.SELECT,
        component: () => import('./views/select.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Select' },
      },
      {
        path: 'components/separator',
        name: UiKitNs.RouteEnums.SEPARATOR,
        component: () => import('./views/separator.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Separator' },
      },
      {
        path: 'components/skeleton',
        name: UiKitNs.RouteEnums.SKELETON,
        component: () => import('./views/skeleton.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Skeleton' },
      },
      {
        path: 'components/slider',
        name: UiKitNs.RouteEnums.SLIDER,
        component: () => import('./views/slider.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Slider' },
      },
      {
        path: 'components/splitter',
        name: UiKitNs.RouteEnums.SPLITTER,
        component: () => import('./views/splitter.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Splitter' },
      },
      {
        path: 'components/editable-heading',
        name: UiKitNs.RouteEnums.EDITABLE_HEADING,
        component: () => import('./views/editable-heading.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Editable Heading' },
      },
      {
        path: 'components/loading',
        name: UiKitNs.RouteEnums.LOADING,
        component: () => import('./views/loading.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · App Loading' },
      },
      {
        path: 'components/pulse',
        name: UiKitNs.RouteEnums.PULSE,
        component: () => import('./views/pulse.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Pulse' },
      },
      {
        path: 'components/outline-card',
        name: UiKitNs.RouteEnums.OUTLINE_CARD,
        component: () => import('./views/outline-card.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Outline Card' },
      },
      {
        path: 'components/content-card',
        name: UiKitNs.RouteEnums.CONTENT_CARD,
        component: () => import('./views/content-card.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Content Card' },
      },
      {
        path: 'components/chat-message',
        name: UiKitNs.RouteEnums.CHAT_MESSAGE,
        component: () => import('./views/chat-message.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Chat Message' },
      },
      {
        path: 'components/thinking',
        name: UiKitNs.RouteEnums.THINKING,
        component: () => import('./views/thinking.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Thinking' },
      },
      {
        path: 'components/sidebar-nav',
        name: UiKitNs.RouteEnums.SIDEBAR_NAV,
        component: () => import('./views/sidebar-nav.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Sidebar Nav' },
      },
      {
        path: 'components/swatch',
        name: UiKitNs.RouteEnums.SWATCH,
        component: () => import('./views/swatch.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Swatch' },
      },
      {
        path: 'components/switch',
        name: UiKitNs.RouteEnums.SWITCH,
        component: () => import('./views/switch.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Switch' },
      },
      {
        path: 'components/table-of-contents',
        name: UiKitNs.RouteEnums.TABLE_OF_CONTENTS,
        component: () => import('./views/table-of-contents.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Table of contents' },
      },
      {
        path: 'components/table',
        name: UiKitNs.RouteEnums.TABLE,
        component: () => import('./views/table.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Table' },
      },
      {
        path: 'components/tabs',
        name: UiKitNs.RouteEnums.TABS,
        component: () => import('./views/tabs.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Tabs' },
      },
      {
        path: 'components/textarea',
        name: UiKitNs.RouteEnums.TEXTAREA,
        component: () => import('./views/textarea.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Textarea' },
      },
      {
        path: 'components/toast',
        name: UiKitNs.RouteEnums.TOAST,
        component: () => import('./views/toast.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Toast' },
      },
      {
        path: 'components/toggle',
        name: UiKitNs.RouteEnums.TOGGLE,
        component: () => import('./views/toggle.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Toggle' },
      },
      {
        path: 'components/tooltip',
        name: UiKitNs.RouteEnums.TOOLTIP,
        component: () => import('./views/tooltip.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Tooltip' },
      },
      {
        path: 'components/logo',
        name: UiKitNs.RouteEnums.LOGO,
        component: () => import('./views/logo.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Logo' },
      },
      {
        path: 'components/tree',
        name: UiKitNs.RouteEnums.TREE,
        component: () => import('./views/tree.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Tree' },
      },
      {
        path: 'components/workspace-item',
        name: UiKitNs.RouteEnums.WORKSPACE_ITEM,
        component: () => import('./views/workspace-item.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Workspace Item' },
      },

      {
        path: 'views/chat',
        name: UiKitNs.RouteEnums.CHAT,
        component: () => import('./views/chat.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Chat' },
      },
      {
        path: 'views/estimation',
        name: UiKitNs.RouteEnums.ESTIMATION,
        component: () => import('./views/estimation.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Estimation' },
      },
      {
        path: 'views/header',
        name: UiKitNs.RouteEnums.HEADER,
        component: () => import('./views/header.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Header' },
      },
      {
        path: 'views/import',
        name: UiKitNs.RouteEnums.IMPORT,
        component: () => import('./views/import.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Import' },
      },
      {
        path: 'views/members',
        name: UiKitNs.RouteEnums.MEMBERS,
        component: () => import('./views/members.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Members' },
      },
      {
        path: 'views/screens',
        name: UiKitNs.RouteEnums.SCREENS,
        component: () => import('./views/screens.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Screens' },
      },
      {
        path: 'views/sidebar',
        name: UiKitNs.RouteEnums.SIDEBAR,
        component: () => import('./views/sidebar.view.vue'),
        meta: { requiresAuth: true, title: 'UI Kit · Sidebar' },
      },
    ],
  },
]
